var scope_0 = require('/var/www/yemeni-projects/bridges/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8d8074e933406570940fdced615e93f3.js').default;export default
        Object.assign({}, scope_0 )
    